import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const updateYear = () => {
      setCurrentYear(new Date().getFullYear());
    };

    const intervalId = setInterval(updateYear, 60000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <footer className='footer'>
      <div className='footer-big-container'>
        <div className='footer-container'>
          <a href='/' className='logo-footer'>
            <img src={`${process.env.PUBLIC_URL}/img/logo-otwarte-pracownie-white.svg`} alt='Logo' />
          </a>
          <nav className='nav-footer'>
            <Link to='/o-wydarzeniu'>O wydarzeniu</Link>
            <Link to='/edycje'>Edycje</Link>
            <Link to='/zostan-partnerem'>Zostań partnerem</Link>
            <Link to='/media'>Dla mediów</Link>
            <Link to='/kontakt'>Kontakt</Link>
          </nav>
        </div>
        <div className='footer-small-text'>
          <p>
            Identyfikacja wizualna Otwartych Pracowni 2025 & 2026 –{' '}
            <a href='mailto:a.trzpilzagorska@gmail.com'>Anna Trzpil-Zagórska</a>
          </p>
          <p>
            Strona internetowa –{' '}
            <a href='mailto:michalmatwijow@gmail.com'>Michał Matwijow</a>
          </p>
          <p>{currentYear} © Wszystkie prawa zastrzeżone</p>
        </div>
      </div>
    </footer>
  );
}
